"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.4a4.6 4.6 0 1 0 4.586 4.234.7.7 0 0 1 1.395-.11q.02.236.019.476a6 6 0 1 1-5.421-5.973.7.7 0 1 1-.134 1.394A5 5 0 0 0 8 3.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.95 7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m3.512 0a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.182 8.446a.7.7 0 0 1 .381.913c-.455 1.11-1.562 1.597-2.553 1.612-.983.014-2.1-.436-2.567-1.503a.7.7 0 0 1 1.283-.56c.172.392.65.672 1.264.663.606-.009 1.095-.298 1.278-.744a.7.7 0 0 1 .914-.381M12 1.8a.7.7 0 0 1 .7.7v.8h.8a.7.7 0 0 1 0 1.4h-.8v.8a.7.7 0 1 1-1.4 0v-.8h-.8a.7.7 0 1 1 0-1.4h.8v-.8a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AddEmojiIcon16.js.map